// extracted by mini-css-extract-plugin
export default {"toggle":"kvBc","toggle-button":"L5A6","toggleButton":"L5A6","toggle-button-link":"dv7m","toggleButtonLink":"dv7m","toggle-button-active":"cFDP","toggleButtonActive":"cFDP"};